import { render, staticRenderFns } from "./create_role.vue?vue&type=template&id=04c9887a&scoped=true"
import script from "./create_role.vue?vue&type=script&lang=js"
export * from "./create_role.vue?vue&type=script&lang=js"
import style0 from "./create_role.vue?vue&type=style&index=0&id=04c9887a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c9887a",
  null
  
)

export default component.exports